<template>
  <div>
    <breadcrumb-header :items="breadcrumbs" />
    <v-card>
      <v-card-title class="text-primary-darken-1 text-wrap py-3 bg-light-grey">
        {{ faq.question }}
      </v-card-title>
      <v-card-text>
        <rich-text-content
          class="mt-2"
          :data="faq.answer"
        />
      </v-card-text>
      <v-card-actions>
        <copy-url
          :model="faq"
        />
        <share-page
          :model="faq"
          :name="t('faq.share')"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CopyUrl from '@/components/carts/CopyUrl.vue';
import SharePage from '@/components/carts/SharePage.vue';
import { useErrorStore } from '@/stores/errors';
import RichTextContent from '../rich-text/RichTextContent.vue';

const props = defineProps<{
  id: string;
}>();
const { t } = useI18n();
const { handleError } = useErrorStore();

const breadcrumbs = computed(() => [
  { title: t('faq.long_title'), to: '/faqs' },
  { title: t('faq.title') },
]);
const faq = ref<Partial<App.Models.Faq>>({ question: '', answer: '' });

async function loadData() {
  try {
    const result = await axios.get(`/api/public/faqs/${props.id}`);
    faq.value = result.data;
  }
  catch (error) {
    handleError(error, t('faq.cannot_load'));
  }
}

loadData();
</script>
